export enum ExpenseStatusType {
  Pending = 1,
  ReleasedToApprover = 2,
  DeclinedByApprover = 3,
  ReleasedToFinance = 4,
  DeclinedByFinance = 5,
  ApprovedByFinance = 6,
  Exported = 7,
  CancelledCredit = 8,
}